"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgEyedropperDrop(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm15.38281.25754a1.51815 1.51815 0 0 0 -1.93893.21546l-1.49834 1.5-.5179-.51847a.73282.73282 0 1 0 -1.0358 1.03694l.5179.51846-4.78736 4.79252a1.81056 1.81056 0 0 0 -.388.57766l-.67745 1.61078a.72755.72755 0 0 0 .15579.79616.72563.72563 0 0 0 .79531.156l1.609-.67824a1.80842 1.80842 0 0 0 .577-.38839l4.78738-4.79261.5179.51851a.73285.73285 0 0 0 1.03585-1.037l-.5179-.51847 1.5537-1.55544a1.46847 1.46847 0 0 0 -.18815-2.23387zm-7.94155 9.12182-1.42053.59876.59815-1.422 4.80876-4.814.82243.82328zm-1.44126 5.42064a1.2 1.2 0 0 1 -2.4 0 11.63354 11.63354 0 0 1 1.2-2.8 11.63354 11.63354 0 0 1 1.2 2.8z' })));
}
exports.default = SvgEyedropperDrop;
